import { render, staticRenderFns } from "./last-events.vue?vue&type=template&id=512f5f13&scoped=true&"
import script from "./last-events.vue?vue&type=script&lang=js&"
export * from "./last-events.vue?vue&type=script&lang=js&"
import style0 from "./last-events.vue?vue&type=style&index=0&id=512f5f13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f5f13",
  null
  
)

export default component.exports